import { Union } from "../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2, Result_Bind } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { lengthEQ, isNotNullOrWhitespace, isOnlyNumbers, lengthLTE, InputType, lengthGT } from "./Common.js";
import { replace } from "../Regex.js";
import { parseInt64 } from "../Utils.js";

export class Icc extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Icc"];
    }
}

export function Icc$reflection() {
    return union_type("Validation.Telecom.Icc", [], Icc, () => [[["Item", string_type]]]);
}

export function Icc__get_Value(this$) {
    return this$.fields[0];
}

export function IccModule_create(getTranslation, str) {
    const _arg = Result_Bind((str_4) => lengthGT(getTranslation, 18, new InputType(0), str_4), Result_Bind((str_3) => lengthLTE(getTranslation, 20, new InputType(0), str_3), Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), isNotNullOrWhitespace(getTranslation, str))));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new Icc(0, _arg.fields[0]));
    }
}

export function IccModule_value(_arg) {
    return _arg.fields[0];
}

export class PhoneNumber extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PhoneNumber"];
    }
}

export function PhoneNumber$reflection() {
    return union_type("Validation.Telecom.PhoneNumber", [], PhoneNumber, () => [[["Item", string_type]]]);
}

export function PhoneNumber__get_Value(this$) {
    return this$.fields[0];
}

export function PhoneNumberModule_create(getTranslation, str) {
    const _arg = Result_Bind((str_3) => lengthLTE(getTranslation, 16, new InputType(0), str_3), Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), isNotNullOrWhitespace(getTranslation, str)));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new PhoneNumber(0, _arg.fields[0]));
    }
}

export function PhoneNumberModule_value(_arg) {
    return _arg.fields[0];
}

export function correctPhoneNumber(countryCode, phoneNumber) {
    if (countryCode.ThreeLetter === "SWE") {
        return replace("^46(.*)", "0$1", replace("[^0-9]*", "", phoneNumber));
    }
    else {
        return phoneNumber;
    }
}

export function isImsi(getTranslation, str) {
    const _arg = Result_Bind((str_3) => lengthEQ(getTranslation, 15, new InputType(0), str_3), Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), isNotNullOrWhitespace(getTranslation, str)));
    if (_arg.tag === 0) {
        const matchValue = parseInt64(_arg.fields[0]);
        if (matchValue != null) {
            return new FSharpResult$2(0, str);
        }
        else {
            return new FSharpResult$2(1, "Not an int64 number.");
        }
    }
    else {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
}

export function isImsiOrIcc(getTranslation, str) {
    return Result_Bind((str_2) => isOnlyNumbers(getTranslation, str_2), isNotNullOrWhitespace(getTranslation, str));
}

